
<template>
  <div>
    <b-overlay
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="lg"
      spinner-variant="primary"
    >
    
      <b-card class="home-card p-5 client-portal">
        <h1 :style="textColor" class="fw-bolder">
          {{ $t("ClientDesk") }} / <i>{{ $t("ClientProfile") }}</i>
        </h1>

        <form
          name="staff_form"
          method="post"
          v-on:submit.prevent="$event.preventDefault()"
        >
          <vs-divider />

          <div class="vx-row images">
            <div class="vx-col w-1/2 mt-5">
              <div class="items-start">
                 <label class="vs-input--label">{{ $t("ProfileImage") }}</label>
                <div>
                  <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
                  <DropFile @selectedFile="selectedFile" :url="url" :bgColor="bgColor"/>
                  <!-- <vs-button type="border" color="danger">Remove</vs-button> -->
                </div>
              </div>
            </div>

            <div class="vx-col w-1/2 mt-5" v-if="crop.src.length">
             <label class="vs-input--label">{{ $t("crop") }}</label>
              <cropper
                id="profile_image"
                ref="cropper"
                class="cropper"
                :src="crop.src"
                :auto-zoom="true"
                :stencil-size="{
                  width: 250,
                  height: 250,
                }"
                image-restriction="stencil"
              />
              <div class="button-wrapper">
                <button
                  class="btn border-primary btn-primary"
                  @click="cropImage"
                >
                  {{ $t("CropImage") }}
                </button>
              </div>
            </div>
          </div>

          <div class="vx-row">
            <!-- required -->

            <div
              class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
            >
              <label :style="textColor" class="vs-input--label"
                >{{ $t("Name") }} <span class="red">*</span></label
              >

              <b-form-input
                size="lg"
                v-validate="'required'"
                :data-vv-as="$t('Name')"
                name="first_name"
                v-model="users.first_name"
                class="w-full"
                @keydown.enter="checkForm"
                :placeholder="$t('Name')"
              ></b-form-input>
              <span :style="textColor"
                class="text-danger text-sm"
                v-show="errors.has('first_name')"
                >{{ errors.first("first_name") }}</span
              >
            </div>

            <div
              class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
            >
              <label :style="textColor" class="vs-input--label"
                >{{ $t("Surname") }}<span class="red">*</span></label
              >

              <b-form-input
                size="lg"
                v-validate="'required'"
                :data-vv-as="$t('Surname')"
                name="last_name"
                v-model="users.last_name"
                class="w-full"
                @keydown.enter="checkForm"
                :placeholder="$t('Surname')"
              ></b-form-input>
              <span
                class="text-danger text-sm"
                v-show="errors.has('last_name')"
                >{{ errors.first("last_name") }}</span
              >
            </div>
            <div
              class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
            >
              <label :style="textColor" class="vs-input--label"
                >{{ $t("Email") }} <span class="red">*</span></label
              >
              <b-form-input
                size="lg"
                :data-vv-as="$t('Email')"
                v-validate="'required|email'"
                name="email"
                v-model="users.email"
                class="w-full"
                @keydown.enter="checkForm"
                :placeholder="$t('Email')"
                readonly
              ></b-form-input>
              <span :style="textColor" class="text-danger text-sm" v-show="errors.has('email')">{{
                errors.first("email")
              }}</span>
            </div>
            <!-- Must only consist of numbers -->
            <!-- Must only consist of numbers -->
            <div
              class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
              id="contact_label"
            >
              <label :style="textColor" class="vs-input--label"
                >{{ $t("PhoneNumber") }}<span class="red">*</span></label
              >

              <vue-tel-input
                size="large"
                v-validate="{
                  required: true,
                  regex: /^(?=.*[0-9])[- +()0-9]+$/,
                  min: 12,
                }"
                name="contact_number"
                v-model="users.contact_number"
                class="w-full contact_number"
                v-bind="bindProps"
                @onInput="onInput"
                @keydown.enter="checkForm"
                :data-vv-as="$t('PhoneNumber')"
                :placeholder="$t('PhoneNumber')"
                :style="bgColor"
              ></vue-tel-input>

              <span :style="textColor"
                id="phone"
                class="text-danger text-sm"
                v-show="errors.has('contact_number')"
                >{{ errors.first("contact_number") }}</span
              >
            </div>
            <div
              class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
            >
              <label class="vs-input--label">{{ $t("Password") }}</label>
              <b-form-input
                type="password"
                size="lg"
                v-validate="'min:8|numbers|upCase|loCase'"
                ref="password"
                :data-vv-as="$t('Password')"
                name="password"
                v-model="newpassword"
                class="w-full"
                @keydown.enter="checkForm"
                @input="displayError"
                :placeholder="$t('Password')"
              ></b-form-input>
              <span
                class="text-danger text-sm"
                v-show="errors.has('password')"
                >{{ errors.first("password") }}</span
              >
            </div>

            <div
              class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
            >
              <label class="vs-input--label">{{ $t("ConfirmPassword") }}</label>
              <b-form-input
                type="password"
                size="lg"
                v-validate="{
                  required: newpassword != '',
                  confirmed: newpassword,
                  min: 8,
                }"
                :data-vv-as="$t('ConfirmPassword')"
                name="confirm_password"
                v-model="confirm_password"
                class="w-full"
                @keydown.enter="checkForm"
                :placeholder="$t('ConfirmPassword')"
              ></b-form-input>
              <span
                class="text-danger text-sm"
                v-show="errors.has('confirm_password')"
                >{{ errors.first("confirm_password") }}</span
              >
            </div>

            <div
              class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
            >
              <label :style="textColor" for="data_nascita">{{ $t("DateOfBirth") }}<span class="red">*</span></label>
              <datepicker
                v-validate="'required'"
                v-model="users.dob"
                class="w-full"
                id="date_of_birth"
                name="date_of_birth"
                :data-vv-as="$t('dob')"
                :placeholder="$t('dob')"
                :max-date="getdate"
                format="dd-MM-yyyy"
              ></datepicker>
              <span :style="textColor"
                class="text-danger text-sm"
                v-show="errors.has('date_of_birth')"
                >{{ errors.first("date_of_birth") }}</span
              >
            </div>
            <div
              class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
            >
              <label :style="textColor" class="vs-input--label"
                >{{ $t("Nationality") }} <span class="red">*</span></label
              >
              <v-select
                v-validate="'required'"
                v-model="users.country"
                :options="countries"
                :reduce="(label) => label.name"
                label="name"
                name="country"
                :placeholder="$t('Nationality')"
                class="w-full"
                :data-vv-as="$t('Nationality')"
                :style="bgColor"
              >
                <template v-slot:option="option">
                  <span :class="option.icon">{{ option.name }} </span>
                  <feather-icon
                    v-if="country.includes(option.name)"
                    icon="CheckIcon"
                    class="float-right"
                    svgClasses="w-5 h-5"
                  />
                </template>
              </v-select>
              <span :style="textColor"
                class="text-danger text-sm"
                v-show="errors.has('country')"
                >{{ errors.first("country") }}</span
              >
            </div>
            <div
              class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
            >
              <label :style="textColor" class="vs-input--label"
                >{{ $t("PlaceOfBirth") }} <span class="red">*</span></label
              >

              <b-form-input
                size="lg"
                v-validate="'required'"
                :data-vv-as="$t('PlaceOfBirth')"
                name="place_of_birth"
                v-model="users.placeofbirth"
                class="w-full"
                @keydown.enter="checkForm"
                :placeholder="$t('PlaceOfBirth')"
              ></b-form-input>
              <span :style="textColor"
                class="text-danger text-sm"
                v-show="errors.has('place_of_birth')"
                >{{ errors.first("place_of_birth") }}</span
              >
            </div>
       <div
              class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
            >
              <label :style="textColor" class="vs-input--label"
                >{{ $t("CountryOfBirth") }} <span class="red">*</span></label
              >
              <v-select
                v-validate="'required'"
                v-model="users.countryofbirth"
                :options="countries"
                :reduce="(label) => label.name"
                label="name"
                name="countryofbirth"
                :placeholder="$t('CountryOfBirth')"
                class="w-full"
                :data-vv-as="$t('CountryOfBirth')"
                :style="bgColor"
              >
                <template v-slot:option="option">
                  <span :class="option.icon">{{ option.name }} </span>
                  <feather-icon
                    v-if="country.includes(option.name)"
                    icon="CheckIcon"
                    class="float-right"
                    svgClasses="w-5 h-5"
                  />
                </template>
              </v-select>
              <span :style="textColor"
                class="text-danger text-sm"
                v-show="errors.has('countryofbirth')"
                >{{ errors.first("countryofbirth") }}</span
              >
            </div>
            <div
              class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
            >
              <label :style="textColor" class="vs-input--label"
                >{{ $t("Sex") }} <span class="red">*</span></label
              >

              <v-select
                v-validate="'required'"
                v-model="users.gender"
                :options="genders"
                name="sex"
                :placeholder="$t('Sex')"
                class="w-full"
                :data-vv-as="$t('Sex')"
                :style="bgColor"
              >
                <template v-slot:option="option">
                  <span :class="option.icon">{{ option.label }} </span>
                  <feather-icon
                    v-if="gender.includes(option.label)"
                    icon="CheckIcon"
                    class="float-right"
                    svgClasses="w-5 h-5"
                  />
                </template>
              </v-select>
              <span :style="textColor" class="text-danger text-sm" v-show="errors.has('sex')">{{
                errors.first("sex")
              }}</span>
            </div>
            <div
              class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
            >
              <label :style="textColor" class="vs-input--label"
                >{{ $t("MaritalStatus") }} <span class="red">*</span></label
              >
              <v-select
                v-validate="'required'"
                v-model="users.maritalstatus"
                :options="statuses"
                name="marital"
                :placeholder="$t('MaritalStatus')"
                class="w-full"
                :data-vv-as="$t('MaritalStatus')"
                :style="bgColor"
              >
                <template v-slot:option="option">
                  <span :class="option.icon">{{ option.label }} </span>
                  <feather-icon
                    v-if="marital.includes(option.label)"
                    icon="CheckIcon"
                    class="float-right"
                    svgClasses="w-5 h-5"
                  />
                </template>
              </v-select>
              <span :style="textColor"
                class="text-danger text-sm"
                v-show="errors.has('marital')"
                >{{ errors.first("marital") }}</span
              >
            </div>
            
          </div>

          <div class="vx-col button-center" id="update ">
            <b-button
             :style="buttonCss"
              type="filled"
              @click.prevent="handleSubmit"
              class="mt-5 br-20 border-primary"
              variant="outline-primary"
              size="lg"
              ><strong :style="buttonCss.color">{{ $t("Save") }}</strong></b-button
            >
          </div>
        </form>
      <div class="mt-2 pt-2" >
          <Back />
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import { getLocalData,clearLocalData } from "@/utils/auth";
import Back from "@/views/users/component/Back";

import $ from "jquery";
// For custom error message
import { Validator } from "vee-validate";
import { VueTelInput } from "vue-tel-input";
import { phoneConfig,names } from "@/utils/helper";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import moment from "moment";
import DropFile from "@/components/DropFile.vue";

export default {
  components: {
    VueTelInput,
    Cropper,
    Datepicker,
    "v-select": vSelect,
    Back,
    DropFile
  },
  

  data() {
    return {
      errorImage: require("@/assets/images/portrait/small/profile-image.png"),
      url: require("@/assets/images/portrait/small/avatar-s-271.png"),
      buttonCss: {},
      textColor: {},
      marital: "",
      gender: "",
      national: "",
      country: "",
      statuses: [
        "Never married",
        "Currently married",
        "Widow",
        "Divorced",
        "Separated",
      ],
      genders: ["Male", "Female", "None of them", "I prefer not to say"],
      countries: names(),
      users: [],
      newpassword: "",
      confirm_password: "",
      currentUser: [],
      first_name: "",
      last_name: "",
      contact_number: "",
      bindProps: phoneConfig(this.$t("ContactNumber")),
      images: null,
      url: require("@/assets/images/portrait/small/avatar-s-271.png"),
      follow: false,
      error: "",
      success: "",
      sec: 2,
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      crop: {
        src: "",
        type: "image/jpg",
      },
      file_name: "",
      bgColor: {}
    };
  },
  computed: {
    getdate() {
      return moment().format("YYYY-MM-DD");
    },
    current_date() {
      return moment().format("DD/MM/YYYY");
    },
  },
  watch: {
    "$i18n.locale": {
      handler: function (value) {
        this.loadLocale(value);
   
      },
    },
  },
  // mounted() {
  //   this.users = this.$store.getters.currentUser;
  // },
  created() {
    this.bindProps.disabledFetchingCountry = true;
    this.getCompanyUsers(this.$store.getters.currentUser.id);
    this.loadLocale(this.$i18n.locale);
           let details = getLocalData();
    if(details.company_id)
    this.getCustomStyle(details.company_id);
  },
  methods: {
     //display error
    displayError() {
      this.$validator.extend("upCase", {
        getMessage: () => this.$t("errorMessage"),
        validate: (value) => value.match(/[A-Z]/g) !== null,
      });
      this.$validator.extend("numbers", {
        getMessage: () => this.$t("errorMessage"),
        validate: (value) => value.match(/[0-9]/g) !== null,
      });
      this.$validator.extend("loCase", {
        getMessage: () => this.$t("errorMessage"),
        validate: (value) => value.match(/[a-z]/g) !== null,
      });
    },
    getCustomStyle(id) {
      let data = {
          company_id: id,
        }; 
      this.$store
        .dispatch("GetCustomStyle", data)
        .then((res) => {
          if (res.data.data.header_text)
            $(".header-text").html(res.data.data.header_text);
          if (res.data.data.footer_text)
            $(".footer-text").html(res.data.data.footer_text);

          $(".home-card, #date_of_birth, .form-control, .vti__input").css({
            "background-color": res.data.data.form_background_color,
          });


          this.bgColor = {
              background: res.data.data.form_background_color
          }

          $(
            "span.vfc-span-day.vfc-disabled.vfc-cursor-not-allowed.vfc-hover, .vfc-day, .vfc-top-date.vfc-center span, span.e-input-group-icon.e-ddl-icon.e-search-icon"
          ).css({ color: res.data.data.form_text_color });
          $(".vfc-arrow-right, .vfc-arrow-left").css({
            "border-color": res.data.data.form_text_color,
          });

          $(".custome-text-color").css({
            color: res.data.data.form_text_color,
          });
          let css = {
            color: this.textColor.color,
            "border-bottom-color": this.textColor.color,
          };
          $(".e-control-wrapper").css(css);
          $("span.e-input-group-icon.e-ddl-icon.e-search-icon").css(
            this.textColor
          );
          this.textColor = {
            color: res.data.data.form_text_color + " !important",
          };

          $(".the-footer p, .the-footer a").css({
            color: res.data.data.form_text_color,
          });

          this.buttonCss = {
            "background-color":
              res.data.data.button_background_color + "!important",
            "border-color":
              res.data.data.button_background_color + "!important",
            color: res.data.data.button_text_color+ "!important",
          };
          if (res.data.data.background_images)
            $("#content-area").css({
              "background-image":
                "url('" + res.data.data.background_images.path + "')",
              "background-position": "center",
              "background-repeat": "no-repeat",
              "background-size": "cover",
            });
          else $("#content-area").css({ "background-image": "none" });
        })
        .catch((error) => {
          this.$log.error(
            "File : Profile.vue | Function : getCustomStyle() | Error :",
            error
          );
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    /**
     * validate phone number
     */
    onInput({ number, isValid, country }) {
      this.users.contact_number = number["international"];
    },
    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },
    /**
     * image validation
     */
    selectedFile(file) {
      this.error = "";
      var filePath = file.name;
      var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
      if (!allowedExtensions.exec(filePath)) {
        this.error = this.$t("FileUploadError");
      } else {
        this.images = file;
        this.file_name = this.images.name;
        this.url = URL.createObjectURL(this.images);
        this.crop.src = URL.createObjectURL(this.images);
      }
    },
    /**
     *
     * checkForm    check profile form     **/
    checkForm() {
      this.handleSubmit();
    },
    /**
     *
     * handleSubmit    method  for submit data from profile form     **/

    handleSubmit() {
      this.success = "";
      this.error = "";

      this.submitted = true;
      this.users.password = this.newpassword;
      this.users.profile_image = this.images;

      this.$validator.validate().then((valid) => {
        if (valid) {
          if (this.newpassword == this.confirm_password) {
            this.show = true;
            let formData = new FormData();
            formData.append("profile_image", this.users.profile_image);
            formData.append("id", this.users.id);
            formData.append("first_name", this.users.first_name);
            formData.append("last_name", this.users.last_name);
            formData.append("password", this.users.password);
            formData.append("contact_number", this.users.contact_number);
            formData.append("company_name", this.users.company_name);
            formData.append("countryofbirth", this.users.countryofbirth);
            formData.append(
              "enable_header_footer",
              this.users.enable_header_footer == true ? 1 : 0
            );
            if(this.users.dob){
              let dob=moment(this.users.dob).format('YYYY-MM-DD');
              formData.append("dob", dob);
            }

            formData.append("gender", this.users.gender);
            formData.append("country", this.users.country);
            formData.append("placeofbirth", this.users.placeofbirth);
            formData.append("maritalstatus", this.users.maritalstatus);
            
            const data = {
              data: formData,
              id: this.users.id,
            };

            if(this.users.profile_image) {
              const user = {...this.$store.state.auth.currentUser};
              user.profile_image = URL.createObjectURL(this.users.profile_image);
              this.$store.commit('SET_USER', user);
            }
            
            this.$store
              .dispatch("UpdateUserProfile", data)
              .then((response) => {
                this.crop.src = "";
                this.success = this.$t("ProfileUpdated");
                this.$toasted.show(this.success, {
                  className: "top-alert",
                  position: "top-center",
                  type: "success",
                  duration: 2000,
                });
                this.show = false;
                this.$router.push({ path: "/" });
              })
              .catch((error) => {
                this.show = false;
                // Error
                this.error =
                  this.$t(error.replace(/[\s\/]/g, "")) !==
                  error.replace(/[\s\/]/g, "")
                    ? this.$t(error.replace(/[\s\/]/g, ""))
                    : error;
                this.$toasted.show(this.error, {
                  className: "top-alert",
                  position: "top-center",
                  type: "error",
                  duration: 2000,
                });
                return false;
              });
          } else {
            this.show = false;
            // Error
            this.error =
              this.$t(error.replace(/[\s\/]/g, "")) !==
              error.replace(/[\s\/]/g, "")
                ? this.$t(error.replace(/[\s\/]/g, ""))
                : error;
            this.$toasted.show(this.error, {
              className: "top-alert",
              position: "top-center",
              type: "error",
              duration: 2000,
            });
            return false;
          }
        }
      });
    },

    /**
     *
     *  getUsers   method  for get data login user     **/

    getCompanyUsers($id) {
      this.show = true;
      this.$store
        .dispatch("ShowUserProfile", $id)
        .then((res) => {
          this.show = false;
          this.bindProps.disabledFetchingCountry = false;
          this.users = res.data.data;
          let users = this.users;
          this.users.contact_number = users.contact_number || "";
          if (res.data.data.profile_image) {
            this.url = res.data.data.profile_image.path;
          }
        })
        .catch((error) => {
          this.$log.error(
            "File : Profile.vue | Function : getCompanyUsers() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    cropImage() {
      const result = this.$refs.cropper.getResult();
      let obj = this;
      this.url = result.canvas.toDataURL(this.crop.type);
      this.urltoFile(
        result.canvas.toDataURL(this.crop.type),
        this.file_name,
        "image/*"
      ).then(function (file) {
        obj.images = file;
        obj.uploadImage();
      });
      this.images = obj.images;
      this.crop.src = "";
    },

    async uploadImage() {
      let formData = new FormData();
      formData.append("profile_image", this.images);
      const user = {...this.$store.state.auth.currentUser};
      user.profile_image = URL.createObjectURL(this.images);
      this.$store.commit('SET_USER', user);
      const data = {
        data: formData,
        id: this.users.id,
      };

      try{ 
        const response  = await this.$store.dispatch("UpdateUserProfile", data)
        this.show = false;
        this.crop.src = "";
        this.success = this.$t("ProfileImageUpdaeteSuccess");
        this.$toasted.show(this.success, {
          className: "top-alert",
          position: "top-center",
          type: "success",
          duration: 2000,
        });
      }catch(error) {
        console.error(error);
      }
    },

    urltoFile(url, filename, mimeType) {
      return fetch(url)
        .then(function (res) {
          return res.arrayBuffer();
        })
        .then(function (buf) {
          return new File([buf], filename, { type: mimeType });
        });
    },
  },
};
</script>

<style  scoped>

.vs__dropdown-menu {
 background: #151515 !important;
}

#update {
  display: inline-flex;
}

#cancel {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  margin-left: 20px;
  margin-top: 20px;
}

.images,
.switch,
.message {
  margin-top: 20px;
}

.contact_number {
  padding: 7px !important;
}

.btn-lg {
  border-radius: 5px;
  font-size: 14px;
}
.button-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 17px;
}

.button {
  color: white;
  font-size: 16px;
  padding: 10px 20px;
  width: 100%;
  background: #151515;
  cursor: pointer;
  transition: background 0.5s;
  border: none;
}
.button-center {
  position: relative;
  left: 47.5%;
}

.back-arrow {
  position: relative;
  bottom: 37px;
  padding: 0 20px;
}
.br-20 {
  border-radius: 20px;
}
.br-10 {
  border-radius: 10px;
}
.w-20 {
  width: 10%;
}

.home-card {
    box-shadow: 0px 3px 8px rgb(100,100,100);
    border-radius: 1.2rem !important;
}

.home-card .card-body {
  background-color: nono !important;
  background: none !important;
 }
</style> 